import dayjs from "dayjs";
import { useMemo } from "react";

const dateTimeFormat = new Intl.DateTimeFormat("en-US", {
  dateStyle: "long",
});

export const formatDate = (value: Date | string | undefined): string => {
  if (!value) return "";

  const date = new Date(value);
  return dateTimeFormat.format(date);
};

export const formatDateCompact = (value: Date | string | null | undefined): string => {
  if (!value) return "";

  const date = new Date(value);
  return dayjs(date).format("DD.MM.YYYY");
};

export function useDate(value: Date | string | undefined) {
  return useMemo(() => formatDate(value), [value]);
}
